import { createContext as t, createElement as e, Component as r } from "react";

function n(t, e) {
  t.prototype = Object.create(e.prototype), t.prototype.constructor = t, t.__proto__ = e;
}

var o = function o() {},
    i = t({
  active: "",
  select: o,
  register: o
}),
    s = function (t) {
  function r() {
    for (var e, r = arguments.length, n = new Array(r), o = 0; o < r; o++) {
      n[o] = arguments[o];
    }

    return (e = t.call.apply(t, [this].concat(n)) || this).state = {
      registeredTabs: [],
      active: e.props.defaultActive,
      register: e.register,
      select: e.select
    }, e.register = function (t) {
      return e.setState(function (e) {
        return {
          registeredTabs: [].concat(e.registeredTabs, [t])
        };
      });
    }, e.select = function (t) {
      return null != e.props.onSelect ? e.props.onSelect(t) : e.setState({
        active: t
      });
    }, e;
  }

  return n(r, t), r.prototype.render = function () {
    var t = this.props,
        r = t.children,
        n = t.active,
        o = t.onSelect,
        s = this.state,
        c = s.active,
        a = s.registeredTabs;
    (null != n && null == o || null != o && null == n) && console.error("Warning: TabsProvider.Tabs can be used either as a controlled or stateful component, when used as controlled component, make sure to define both `value` and `onSelect` properties to it.");
    var p = n || c || a[0];
    return e(i.Provider, {
      value: {
        active: p,
        register: this.register,
        select: this.select
      }
    }, r({
      active: p
    }));
  }, r;
}(r),
    c = function (t) {
  function e() {
    return t.apply(this, arguments) || this;
  }

  return n(e, t), e.prototype.render = function () {
    return this.props.children(this.context);
  }, e;
}(r);

c.contextType = i;

var a = function (t) {
  function e() {
    return t.apply(this, arguments) || this;
  }

  n(e, t);
  var r = e.prototype;
  return r.componentDidMount = function () {
    this.context.register(this.props.name);
  }, r.render = function () {
    return this.props.name === this.context.active ? this.props.children({
      name: this.props.name
    }) : null;
  }, e;
}(r);

a.contextType = i;
export default function () {
  return null;
}
export { c as TabList, a as TabPanel, s as Tabs };